module.exports = __webpack_public_path__ + "img/provider-claude.3d517229.png";